import { render, staticRenderFns } from "./orgDeduction.vue?vue&type=template&id=ab7948e2&scoped=true"
import script from "./orgDeduction.vue?vue&type=script&lang=js"
export * from "./orgDeduction.vue?vue&type=script&lang=js"
import style0 from "./orgDeduction.vue?vue&type=style&index=0&id=ab7948e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab7948e2",
  null
  
)

export default component.exports